import CustomUspMinute from '@public/icons/usp_4_new.svg';
import { SVGProps } from 'react';

type CustomUspMinuteWrapperProps = SVGProps<SVGSVGElement>;
const CustomUspMinuteWrapper = (props: CustomUspMinuteWrapperProps) => {
  return <CustomUspMinute {...props} />;
};

export default CustomUspMinuteWrapper;
